// src/pages/Auth/LoginScreen.js
import React, { useState, useRef, useEffect } from 'react';
import { getAuth, signInWithEmailAndPassword, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

function LoginScreen() {
  const [email, setEmail] = useState('kode-essens@hotmail.com');
  const [passord, setPassord] = useState('');
  const [feil, setFeil] = useState('');
  const navigate = useNavigate();
  const passordInputRef = useRef(null);

  const ADMIN_UID = '3N1QaQpLuRfJXNPUypBXBE61V3F3'; // ✅ Admin UID

  useEffect(() => {
    passordInputRef.current?.focus();
  }, []);

  const loggInn = async () => {
    const auth = getAuth();
    try {
      await setPersistence(auth, browserLocalPersistence);
      const result = await signInWithEmailAndPassword(auth, email, passord);

      const user = result.user;

      // ✅ Naviger riktig ut fra rolle
      if (user.uid === ADMIN_UID) {
        navigate('/admin');
      } else {
        navigate('/myessence');
      }

    } catch (error) {
      console.error('🔐 Login-feil:', error);
      setFeil('⚠️ Feil e-post eller passord.');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      loggInn();
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black text-white">
      <h1 className="text-2xl font-semibold mb-6">🔐 Admin Login</h1>

      <input
        type="email"
        placeholder="E-post"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="mb-4 px-4 py-2 rounded w-72 text-black"
      />

      <input
        type="password"
        placeholder="Passord"
        value={passord}
        onChange={(e) => setPassord(e.target.value)}
        onKeyDown={handleKeyDown}
        ref={passordInputRef}
        className="mb-4 px-4 py-2 rounded w-72 text-black focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

      <button
        onClick={loggInn}
        className="bg-sky-400 hover:bg-sky-500 text-black px-4 py-2 rounded"
      >
        Logg inn
      </button>

      {feil && <p className="text-red-500 mt-4">{feil}</p>}
    </div>
  );
}

export default LoginScreen;
